// ─────────────────────────────────────────────────────────────────────────────
// Mock Income Data — matches shape of API_PATHS.INCOME_LIST response
// Used in: Income.jsx
// ─────────────────────────────────────────────────────────────────────────────

export const mockIncomeListResponse = {
  rescode: 1,
  message: "Income list fetched successfully",
  data: {
    incomeCount: 12,

    // Analytics cards
    stats: {
      totalIncome: 160500,
      thisMonth: 82500,
      cashIncome: 68300,
      onlineIncome: 92200,
      change: "+14%",
    },

    // Category breakdown for chart
    categoryBreakdown: [
      { category: "Session Fee",     amount: 98200,  color: "#10b981" },
      { category: "Evaluation Fee",  amount: 28500,  color: "#3b82f6" },
      { category: "Workshop",        amount: 12500,  color: "#8b5cf6" },
      { category: "Group Session",   amount: 11300,  color: "#f59e0b" },
      { category: "Donation",        amount: 10000,  color: "#ef4444" },
    ],

    incomes: [
      { id: 1,  category: "Session Fee",    invoice_id: 1001, date: "2026-01-05", payment_method: "Cash",   amount: 5000,  patient_name: "Aryan Sharma",    notes: "" },
      { id: 2,  category: "Session Fee",    invoice_id: 1003, date: "2026-01-20", payment_method: "Online", amount: 12000, patient_name: "Rohit Patel",     notes: "Full payment received" },
      { id: 3,  category: "Evaluation Fee", invoice_id: 1004, date: "2026-02-01", payment_method: "Cash",   amount: 3000,  patient_name: "Meera Gupta",     notes: "Partial payment" },
      { id: 4,  category: "Session Fee",    invoice_id: 1005, date: "2026-02-08", payment_method: "Online", amount: 9000,  patient_name: "Kabir Singh",     notes: "" },
      { id: 5,  category: "Workshop",       invoice_id: 0,    date: "2026-02-10", payment_method: "Online", amount: 2500,  patient_name: "",                notes: "Parent awareness workshop" },
      { id: 6,  category: "Session Fee",    invoice_id: 1007, date: "2026-02-18", payment_method: "Cash",   amount: 4500,  patient_name: "Vivaan Joshi",    notes: "" },
      { id: 7,  category: "Evaluation Fee", invoice_id: 1008, date: "2026-02-22", payment_method: "Online", amount: 5500,  patient_name: "Diya Kapoor",     notes: "" },
      { id: 8,  category: "Group Session",  invoice_id: 0,    date: "2026-02-25", payment_method: "Cash",   amount: 1800,  patient_name: "",                notes: "Group OT session" },
      { id: 9,  category: "Session Fee",    invoice_id: 1009, date: "2026-03-01", payment_method: "Online", amount: 15000, patient_name: "Aditya Kumar",    notes: "" },
      { id: 10, category: "Donation",       invoice_id: 0,    date: "2026-03-03", payment_method: "Online", amount: 10000, patient_name: "",                notes: "Annual charity event" },
      { id: 11, category: "Session Fee",    invoice_id: 1011, date: "2026-03-05", payment_method: "Cash",   amount: 8500,  patient_name: "Riya Desai",      notes: "" },
      { id: 12, category: "Evaluation Fee", invoice_id: 1012, date: "2026-03-06", payment_method: "Cash",   amount: 2000,  patient_name: "Navya Choudhary", notes: "Initial evaluation" },
    ],
  },
};

// ─────────────────────────────────────────────────────────────────────────────
// Mock Expense Data — matches shape of API_PATHS.EXPENSE_LIST response
// Used in: Expense.jsx
// ─────────────────────────────────────────────────────────────────────────────

export const mockExpenseListResponse = {
  rescode: 1,
  message: "Expense list fetched successfully",
  data: {
    expenseCount: 12,

    // Analytics cards
    stats: {
      totalExpenses: 189400,
      thisMonth: 89000,
      operationalCost: 52700,
      staffSalary: 96000,
      change: "+6%",
    },

    // Category breakdown for chart
    categoryBreakdown: [
      { category: "Staff Salary",        amount: 96000,  color: "#ef4444" },
      { category: "Rent",                amount: 50000,  color: "#f59e0b" },
      { category: "Equipment",           amount: 15000,  color: "#3b82f6" },
      { category: "Therapy Materials",   amount: 8500,   color: "#8b5cf6" },
      { category: "Utilities",           amount: 7000,   color: "#10b981" },
      { category: "Maintenance",         amount: 4200,   color: "#6366f1" },
      { category: "Software",            amount: 2999,   color: "#ec4899" },
      { category: "Stationery",          amount: 1200,   color: "#14b8a6" },
    ],

    expenses: [
      { id: 1,  category: "Staff Salary",        vendor: "Payroll",       invoice_id: 0,    date: "2026-01-31", payment_method: "Online", amount: 48000, notes: "January salary" },
      { id: 2,  category: "Utilities",            vendor: "BSES",          invoice_id: 0,    date: "2026-02-05", payment_method: "Online", amount: 3500,  notes: "Electricity bill" },
      { id: 3,  category: "Equipment",            vendor: "MedEquip Co",   invoice_id: 2001, date: "2026-02-08", payment_method: "Online", amount: 15000, notes: "Therapy equipment" },
      { id: 4,  category: "Rent",                 vendor: "Landlord",      invoice_id: 0,    date: "2026-02-10", payment_method: "Cash",   amount: 25000, notes: "February rent" },
      { id: 5,  category: "Stationery",           vendor: "Office Store",  invoice_id: 0,    date: "2026-02-12", payment_method: "Cash",   amount: 1200,  notes: "" },
      { id: 6,  category: "Therapy Materials",    vendor: "EduSupply",     invoice_id: 2002, date: "2026-02-15", payment_method: "Online", amount: 8500,  notes: "Sensory integration kit" },
      { id: 7,  category: "Maintenance",          vendor: "Handyman",      invoice_id: 0,    date: "2026-02-20", payment_method: "Cash",   amount: 4200,  notes: "AC repair" },
      { id: 8,  category: "Software Subscription", vendor: "TechCo",      invoice_id: 2003, date: "2026-02-25", payment_method: "Online", amount: 2999,  notes: "Monthly subscription" },
      { id: 9,  category: "Staff Salary",         vendor: "Payroll",       invoice_id: 0,    date: "2026-02-28", payment_method: "Online", amount: 48000, notes: "February salary" },
      { id: 10, category: "Rent",                 vendor: "Landlord",      invoice_id: 0,    date: "2026-03-01", payment_method: "Cash",   amount: 25000, notes: "March rent" },
      { id: 11, category: "Utilities",            vendor: "Airtel",        invoice_id: 0,    date: "2026-03-03", payment_method: "Online", amount: 3500,  notes: "Internet bill" },
      { id: 12, category: "Therapy Materials",    vendor: "TherapyTools",  invoice_id: 2004, date: "2026-03-05", payment_method: "Online", amount: 4500,  notes: "Play therapy items" },
    ],
  },
};
